
import { Component, Vue } from 'vue-property-decorator';
import AuthRepository from '@/services/Auth';
import { SocialInterface } from '@/views/interfaces/socials.interface';
import ProfileRepository from '@/services/Users-profile';

@Component({
  components: {
    PagesBtn: () => import('./components/Btn.vue'),
  },
  inject: [
    'authRepository',
    'profileRepository',
  ],
})
export default class PagesLogin extends Vue {
  private readonly authRepository!: AuthRepository;
  private readonly profileRepository!: ProfileRepository;

  private username: string = '';

  private password: string = '';

  private error: string = '';

  private socials: SocialInterface[] = [
    {
      href: '#',
      icon: 'mdi-facebook',
    },
    {
      href: '#',
      icon: 'mdi-twitter',
    },
    {
      href: '#',
      icon: 'mdi-github',
    },
  ];

  private async login(): Promise<void> {
    try {
      const loginData = await this.authRepository.login(this.username, this.password);
      this.$store.commit('USER_LOGIN', loginData);

      const profile = await this.profileRepository.getOneByUserId(loginData.id);
      if (profile) {
        this.$store.commit('SET_PROFILE_DATA', profile);
      }

      this.$socket.io.opts.query = { key: loginData.jwt };
      this.$socket.connect();
      await this.$router.push({ name: 'home' });
      this.$vuetify.theme.dark = profile?.profileConfig?.enabledDarkTheme || false;
    } catch (err) {
      console.log(err);
      this.error = `${err.response?.data?.message}`;
      return;
    }
  }
}
